const state = {
  property : { page : 1, perPage : 10 },
  request  : { page : 1, perPage : 10 }
};

const getters = {
  propertyPagination : state => state.property,
  requestPagination  : state => state.request
};

const mutations = {
  SET_PAGINATION : (state, { model, pagination }) => {

    state[model] = pagination;
  }
};

const actions = {
  updatePagination({ commit }, { model, pagination }) {

    commit('SET_PAGINATION', { model, pagination });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
